import ErrorPageLayout from 'pages/Error/ErrorPageLayout';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import image from './images/session-expired.svg';

const getInstitutionLaunchUrl = () => {
    const target = process.env.REACT_APP_INSTITUTION_LAUNCH_URL || '/api-launch';
    const launchUrl = new URL(target, window.location.origin);

    return ['http:', 'https:'].includes(launchUrl.protocol)
        ? launchUrl
        : new URL('/api-launch', window.location.origin);
};

const SessionExpired = () => {
    const history = useHistory();
    const { t } = useTranslation();

    const handleReauthorize = () => {
        const launchUrl = getInstitutionLaunchUrl();
        if (launchUrl.origin === window.location.origin) {
            return history.push(`${launchUrl.pathname}${launchUrl.search}${launchUrl.hash}`);
        }
        window.location.assign(launchUrl.href);
    };

    return (
        <ErrorPageLayout
            action={{
                label: t('common:errors.reauthorize', 'Reauthorize'),
                onClick: handleReauthorize,
            }}
            description={t(
                'common:errors.session-expired-description',
                'Your session has expired.\nPlease log back in to continue using TimelyGrader.'
            )}
            image={image}
            imageAlt={t('common:errors.session-expired-illustration', 'Sleeping Hugo illustration')}
            imageHeight={150}
            imageWidth={298}
            title={t('common:errors.session-expired-title', 'Session Expired')}
        />
    );
};

export default SessionExpired;
